module.exports = "/lucky-balls/img/combos-sr/201.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/combos-sr/201.png
// module id = 985
// module chunks = 0